export default {
  EXCHANGE_LETTERS: 0,
  RECONNECTED: 1,
  DISCONNECTED: 2,
  TIMEOUT: 3,
  PASSED: 4,
  TURN: 5,
  INCORRECT_WORDS: 6,
  N_TRIES_LEFT: 7,
  WORDS: 8,
  MESSAGE: 9,
  GAVEUP: 10,
  ENDGAME_DROP: 11,
  ENDGAME_SCORE: 12,
  ENDGAME_WINNER: 13,
  ENDGAME_DRAW: 14,
  BOGUS_CHARS_GIVEN: 15,
  NOT_ALLOWED_TO_SWAP: 16,
  OCCUPIED_SQUARE: 17,
  START_IN_THE_MIDDLE: 18,
  ONE_CHAR_WORD_NOT_ALLOWED: 19,
  NOT_ATTACHED_CHAR: 20,
  NOT_IN_LINE: 21,
  WE_GOT_GAPS: 22,
  PAUSE_IN_PROGRESS: 23,
  GAME_ENDED_ABRUPT: 24,
  SPY_JOINED: 25,
  SPY_PARTED: 26,
  MISSED_TRIES: 27,
  PLAYING_EMPTY_JOKER: 28,
  ROLLED: 29,
  ENDGAME_RATING: 30,
  PAUSED: 31,
  UNPAUSED: 32,
  PAUSE_REQUEST: 33,
  PAUSE_RESPONSE: 34,
};
